import {TrustSurveyBanner} from 'components/TrustSurvey'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

interface Props {
  onTrustSurveyVisibilityChange: (input: boolean) => void
}

export const SearchResultsTrustBanners = ({
  onTrustSurveyVisibilityChange
}: Props) => {
  const toggle = useToggle()

  return toggle(
    'feature-survey-banner',
    null,
    <TrustSurveyBanner onVisibilityChange={onTrustSurveyVisibilityChange} />
  )
}
